const permissionsType = {
    manage: 'manage',
    read: 'read',
    cant: ''
}

export default permissionsType